import { useEffect, useState } from 'react';
import MoonIcon from './MoonIcon';
import './style.scss';
import SunIcon from './SunIcon';
import { ROUTE_MAP } from 'consts/url';

const DAY_NIGHT_SCENE = {
  '691fc3099d4e2e854cdc32ed': {
    label: 'Sảnh (day-time)',
    url: `/${ROUTE_MAP.amenities.id}/lobby-day-time`,
    oppositeSceneId: '691fcb159d4e2e854cdc39ba', // Sảnh night
    type: 'sanh',
  },
  '691fcb159d4e2e854cdc39ba': {
    label: 'Sảnh (night-time)',
    url: `/${ROUTE_MAP.amenities.id}/lobby-night-time`,
    oppositeSceneId: '691fc3099d4e2e854cdc32ed', // Sảnh day
    type: 'sanh',
  },
  '691fc3199d4e2e854cdc3311': {
    label: 'Tiểu cảnh (day-time)',
    url: `/${ROUTE_MAP.amenities.id}/landscape-feature-day-time`,
    oppositeSceneId: '691fcb2c9d4e2e854cdc39d2', // Tiểu cảnh night
    type: 'tieu-canh',
  },
  '691fcb2c9d4e2e854cdc39d2': {
    label: 'Tiểu cảnh (night-time)',
    url: `/${ROUTE_MAP.amenities.id}/landscape-feature-night-time`,
    oppositeSceneId: '691fc3199d4e2e854cdc3311', // Tiểu cảnh day
    type: 'tieu-canh',
  },
  '6937e9656d92902188729582': {
    label: 'Sunken Garden (night-time)',
    url: `/${ROUTE_MAP.amenities.id}/sunken-garden`,
    oppositeSceneId: '6960673caa52f489bfdc9e33',
    type: 'garden',
  },
  '6960673caa52f489bfdc9e33': {
    label: 'Above Sunken Garden (day-time)',
    url: `/${ROUTE_MAP.amenities.id}/above-sunken-garden`,
    oppositeSceneId: '6937e9656d92902188729582',
    type: 'garden',
  },
};

export default function DayTimeSwitch({
  currentPano,
  selectSceneById = () => { },
}) {
  const [isDayLight, setIsDayLight] = useState(false);

  const getDayNightText = () => {
    return isDayLight ? 'DAY' : 'NIGHT';
  };

  useEffect(() => {
    const scene = DAY_NIGHT_SCENE[currentPano?._id];
    if (scene) {
      setIsDayLight(
        scene.url.includes('day-time') || scene.label.includes('day-time')
      );
    }
  }, [currentPano?._id]);

  const onSwitchDayNight = () => {
    if (!currentPano?._id || !currentPano?.groupId) return;

    // Tìm scene hiện tại trong DAY_NIGHT_SCENE
    const currentScene = DAY_NIGHT_SCENE[currentPano._id];
    if (!currentScene) return;

    // Lấy scene đối lập (day <-> night) trong cùng loại (sảnh hoặc tiểu cảnh)
    const oppositeSceneId = currentScene.oppositeSceneId;
    if (!oppositeSceneId) return;

    // Switch sang scene đối lập
    selectSceneById(currentPano.groupId, oppositeSceneId);
  };

  return (
    <div
      className={`daytime-switch ${isDayLight ? '' : 'night'}`}
      onClick={onSwitchDayNight}
    >
      <div className={`daytime-switch-icon ${isDayLight ? '' : 'night'}`}>
        {isDayLight ? <SunIcon /> : <MoonIcon />}
      </div>
      <div className={`daytime-switch-text ${isDayLight ? '' : 'night'}`}>
        <span className="dt-text-content">{getDayNightText()}</span>
      </div>
    </div>
  );
}
